function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
import * as React from 'react';
import SvgButton from "../../basic/SvgButton";
import { color, font, zIndex, spacing } from "../../../styles/theme";
import { SvgArrowLeft } from "../../../svg";
import { lighten } from "../../../utils/colorUtils";
var BUTTON_SIZE = 72; // px
var BUTTON_BG_COLOR = lighten(color.black, 0.1); // TODO: use 'var(--cds-color-grey-900, #202F3A)' once design consolidates

var CONFIG = {
  TunnelVisionClose: {
    'display': 'inline-block',
    'backgroundColor': BUTTON_BG_COLOR,
    'height': BUTTON_SIZE,
    'width': BUTTON_SIZE,
    'overflow': 'hidden',
    'cursor': 'pointer',
    'border': 'none',
    'borderRadius': 0,
    'padding': 0,
    ':hover': {
      backgroundColor: BUTTON_BG_COLOR,
      border: 'none'
    }
  },
  tunnelVisionCloseTooltip: function tunnelVisionCloseTooltip(closeButtonAlignment) {
    return {
      ':after': _objectSpread(_objectSpread({
        content: '"Back to Content"',
        color: color.white,
        background: lighten(color.black, 0.2),
        padding: spacing.sm,
        position: 'fixed'
      }, closeButtonAlignment === 'right' ? {
        right: 0
      } : {
        left: '-9999px'
      }), {}, {
        opacity: 0,
        bottom: '100%',
        whiteSpace: 'nowrap',
        transition: 'opacity .15s ease-in-out',
        fontSize: font.sm,
        minWidth: BUTTON_SIZE
      }),
      ':hover:after': _objectSpread(_objectSpread({}, closeButtonAlignment === 'right' ? {
        right: 0
      } : {
        left: 0
      }), {}, {
        top: BUTTON_SIZE,
        opacity: 1,
        zIndex: zIndex.xl,
        height: 36,
        pointerEvents: 'none'
      })
    };
  }
};
var TunnelVisionClose = function TunnelVisionClose(_ref) {
  var closeElement = _ref.closeElement,
    showTooltip = _ref.showTooltip,
    handleClose = _ref.handleClose,
    backbuttonAriaLabel = _ref.backbuttonAriaLabel,
    closeButtonAlignment = _ref.closeButtonAlignment;
  var customStyles = {
    Button: CONFIG.TunnelVisionClose
  };
  if (showTooltip) {
    // merge tooltip styles
    customStyles.Button = Object.assign({}, customStyles.Button, CONFIG.tunnelVisionCloseTooltip(closeButtonAlignment));
  }
  return /*#__PURE__*/React.createElement(SvgButton, {
    rootClassName: "rc-TunnelVisionClose",
    onClick: handleClose,
    type: "noStyle",
    svgElement: closeElement || /*#__PURE__*/React.createElement(SvgArrowLeft, {
      color: color.white,
      size: BUTTON_SIZE / 1.5
    }),
    customStyles: customStyles,
    htmlAttributes: {
      'aria-label': backbuttonAriaLabel || 'Close Tunnel Vision',
      'data-classname': 'TunnelVisionClose',
      'name': 'Tunnel Vision Close'
    }
  });
};
export default TunnelVisionClose;